import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'antd/dist/reset.css';
import { Provider } from 'react-redux'
import store from './store'
import { loader } from '@monaco-editor/react';
// 配置 Monaco 使用本地文件
loader.config({
  paths: {
    vs: '/monaco-editor/min/vs'  // 指向 public 目录
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
const AppView =() =>  (
    <Provider store={store}>
        <App />
    </Provider>
)
root.render(
    <AppView />
);
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

reportWebVitals();
